import { ChevronLeft, ChevronRight } from 'lucide-react-native';
import { HStack, IconButton, Text } from '../../../components/primitives';
import { Button } from '../../../components/primitives/Button';
import { colors } from '../../../theme/colors';

interface CalendarPeriodHeaderProps {
  label: string;
  onPrevious: () => void;
  onNext: () => void;
  onToday: () => void;
}

export function CalendarPeriodHeader({
  label,
  onPrevious,
  onNext,
  onToday,
}: Readonly<CalendarPeriodHeaderProps>) {
  return (
    <HStack spacing="sm" align="center">
      <IconButton
        testID="calendar_period_previous"
        icon={<ChevronLeft size={18} color={colors.text.secondary} strokeWidth={2} />}
        variant="ghost"
        size="sm"
        accessibilityLabel="Previous period"
        onPress={onPrevious}
      />
      <Text
        variant="body"
        color={colors.text.primary}
        style={{ fontWeight: '600', minWidth: 180, textAlign: 'center' }}
        accessibilityLiveRegion="polite"
      >
        {label}
      </Text>
      <IconButton
        testID="calendar_period_next"
        icon={<ChevronRight size={18} color={colors.text.secondary} strokeWidth={2} />}
        variant="ghost"
        size="sm"
        accessibilityLabel="Next period"
        onPress={onNext}
      />
      <Button variant="outline" size="sm" onPress={onToday} accessibilityLabel="Go to today">
        Today
      </Button>
    </HStack>
  );
}
